import Point from '@arcgis/core/geometry/Point';
import Graphic from '@arcgis/core/Graphic';
import RouteLayer from '@arcgis/core/layers/RouteLayer';
import RouteParameters from '@arcgis/core/rest/support/RouteParameters';
import { DEFAULT_MAP_SOURCE } from '@env';
import { Position } from 'geojson';

import { Injectable } from '@angular/core';

import { COLORS } from '@lib/ui/theme';
import { FsMap } from '@lib/geo/map/types';
// import LineSymbol from '@arcgis/core/symbols/LineSymbol';

@Injectable({
  providedIn: 'root',
})
export class MapRouteService {
  private _map: FsMap;
  private _routeLayer: google.maps.DirectionsService | RouteLayer;
  private _polylines: google.maps.Polyline[] | Graphic[] = [];

  constructor() {}

  get defaultMapSource(): string {
    return DEFAULT_MAP_SOURCE;
  }

  public initializeMapRouteServices(map: FsMap): void {
    this._map = map;
    if (this.defaultMapSource === 'google') {
      this._routeLayer = new google.maps.DirectionsService();
    } else {
      this._routeLayer = new RouteLayer();
      this._map.addLayer(this._routeLayer);
    }
  }

  public calculateMapRoute(origin: Position, destination: Position): void {
    if (this.defaultMapSource === 'google') {
      this._calculateGoogleRoute(origin, destination);
    } else {
      this._calculateEsriRoute(origin, destination);
    }
  }

  public clearPolylines(): void {
    if (this._polylines.length) {
      this._polylines.forEach((polyline) => {
        polyline.setMap(null);
      });
      this._polylines = [];
    }
  }

  private _calculateGoogleRoute(origin: Position, destination: Position): void {
    (this._routeLayer as unknown as google.maps.DirectionsService).route(
      {
        origin: new google.maps.LatLng(origin[1], origin[0]),
        destination: new google.maps.LatLng(destination[1], destination[0]),
        provideRouteAlternatives: true,
        travelMode: google.maps.TravelMode.DRIVING,
        drivingOptions: {
          departureTime: new Date(),
          trafficModel: google.maps.TrafficModel.BEST_GUESS,
        },
      },
      (result, status) => {
        if (this._polylines.length) {
          (this._polylines as unknown as google.maps.Polyline[]).forEach(
            (polyline: google.maps.Polyline) => {
              polyline.setMap(null);
            },
          );
        }
        if (status === 'OK' && result?.routes?.length) {
          this._displayGoogleRoutes(result.routes);
        }
      },
    );
  }

  private _displayGoogleRoutes(routes: google.maps.DirectionsRoute[]): void {
    routes.forEach((route, index) => {
      const polyline = new google.maps.Polyline({
        path: route.overview_path,
        visible: true,
        zIndex: index === 0 ? 1000 : 999,
        strokeColor: index === 0 ? '#0196d3' : COLORS['grey-400'],
        strokeOpacity: index === 0 ? 1 : 0.8,
        strokeWeight: 3,
        map: this._map.mapInstance as unknown as google.maps.Map,
      });
      (this._polylines as unknown as google.maps.Polyline[]).push(polyline);
    });
  }

  private _calculateEsriRoute(origin: Position, destination: Position): void {
    const originPoint = new Point({ latitude: origin[1], longitude: origin[0] });
    const destinationPoint = new Point({ latitude: destination[1], longitude: destination[0] });

    const routeParams = new RouteParameters({
      stops: [{ geometry: originPoint }, { geometry: destinationPoint }],
    });

    // TODO: Enable when we have the ArcGIS Pro key setup
    // (this._routeLayer as unknown as RouteLayer).solve(routeParams).then((result: any) => {
    //   if (this._polylines.length) {
    //     this.clearPolylines();
    //   }
    //   result.routeResults.forEach((route: any, index: number) => {
    //     const polyline = new Graphic({
    //       geometry: route.route.geometry,
    //       symbol: new LineSymbol({
    //         color: index === 0 ? '#0196d3' : COLORS['grey-400'],
    //         width: 3
    //       })
    //     });
    //     this._map.addLayer(polyline);
    //     (this._polylines as unknown as Graphic[]).push(polyline);
    //   })
    // })
  }
}
